import Image from "components/Image";
import Link from "./Link";
import Snippet from "./Snippet";
import Chat from "./Chat";
import Table from "./Table";
import Blockquote from "./Blockquote";
import UnorderedList from "./UnorderedList";
import OrderedList from "./OrderedList";
import StandardTable from "./StandardTable";
import Paragraph from "./Paragraph";
import SlimCTA from "components/SlimCTA";
import AppPadder from "components/Padder";
import ResourceOverview from "components/ResourceOverview";
import ResourceMethod from "components/ResourceMethod";

const Padder = () => <AppPadder theme="visible" />;

const BlogImage = (props) => (
  <div className="w-100 tc">
    <Image {...props} />
  </div>
);

const Code = (props) => {
  <code {...props}></code>;
};

const ComponentRegistry = {
  Image: BlogImage,
  a: Link,
  p: Paragraph,
  ul: UnorderedList,
  ol: OrderedList,
  table: StandardTable,
  blockquote: Blockquote,
  code: Code,
  Snippet,
  Table,
  Chat,
  SlimCTA,
  Padder,
  ResourceOverview,
  ResourceMethod
};

export default ComponentRegistry;
